import { useEffect } from 'react';
import { paths } from 'src/routes/paths';

/** Legacy route — display rules live inside redpacket config. */
export default function SocialTradingRedpacketDisplayRulesList() {
  useEffect(() => {
    window.location.replace(paths.socialTrading.redpacketConfig.root);
  }, []);
  return null;
}
